import { ITrackingProvider } from '../interface';
import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class NoopTrackingProvider implements ITrackingProvider<{}> {
  init(): void {}
  setUserData(): void {}
  track(): void {}
  page(): void {}
  resetUser(): void {}
  setSource(): void {}
}
